export const COMPANY = {
  name: "Diotech",
  tagline: "Soluzioni informatiche",
  logoUrl: "https://customer-assets-7cd3h4nn.emergentagent.net/job_shop-work-manager/artifacts/2j7ye9hc_Logo_Diotech.webp",
  address: "",
  phone: "3209613945",
  email: "assistenza@diotech.it",
  email2: "amministrazione@diotech.it",
  website: "www.diotech.it",
  vat: "",
};
